import React, { useState } from "react";


const BG = () => {

    const purple = "#8e44ed";
    const [bgg, setBg] = useState(purple);
    const [name, setName] = useState("Click Me!");

    const bgChange = () => {
        //console.log("Clicked");
        let newBg ="yellow";
        setBg(newBg);
        setName('Ouch !');
    }

    const bgChangeback = () => {
        setBg(purple);
        setName('Ouch Ouch !');
    }

    return (
        <>
            <div style={{ backgroundColor: bgg }}>
                <button onClick={bgChange}  onDoubleClick={bgChangeback}> {name}</button>
            </div>
        </>
    )
}

export default BG;